export default function video() {
  const videos = document.querySelectorAll('[data-video]')

  videos.forEach(videoBlock => {
    const button = videoBlock.querySelector('.video-block__play-button')
    const video = videoBlock.querySelector('video')

    button.addEventListener('pointerover', onPointerOverButton.bind(null, event, videoBlock))
    button.addEventListener('pointerout', onPointeroutButton.bind(null, event, videoBlock))
    button.addEventListener('click', onClickButton.bind(null, event, video))
    video.addEventListener('play', onPlayPauseVideo.bind(null, event, videoBlock))
    video.addEventListener('pause', onPlayPauseVideo.bind(null, event, videoBlock))


  })

  function onPointerOverButton(event, videoBlock) {
    videoBlock.classList.add('hover')
  }

  function onPointeroutButton(event, videoBlock) {
    videoBlock.classList.remove('hover')
  }

  function onClickButton(event, video) {
    video.play()
  }

  function onPlayPauseVideo(event, videoBlock) {
    toggleVideoBlockState(videoBlock)
  }

  function toggleVideoBlockState(videoBlock) {
    const poster = videoBlock.querySelector('.video-block__poster')
    const video = videoBlock.querySelector('video')

    if (video.paused === false) {
      poster.classList.add('hidden')
      video.classList.add('visible')
    }
    else {
      poster.classList.remove('hidden')
      video.classList.remove('visible')
    }
  }
}